import React from 'react';

const LogosBar: React.FC = () => {
  const companies: string[] = ['Zalando', 'Mollie', 'Zara', '3M', 'Carclick', 'Fabella'];

  return (
    <div className="logos-bar">
      <p className="label">Preferred by Leading Teams At</p>
      <div className="logos-row">
        {companies.map((company, index) => (
          <span key={index}>{company}</span>
        ))}
      </div>
    </div>
  );
};

export default LogosBar;
